import React, { useState, useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "./assets/style.css";
import { auth, db } from "./firebase";
import { Element, scroller } from "react-scroll";
import { Tooltip as ReactTooltip } from "react-tooltip";
import firebase from "firebase/compat/app";

const Chapter4_2 = () => {
  const navigate = useNavigate();
  const [selectedAnswers, setSelectedAnswers] = useState({ q1: "", q2: "" });
  const [error, setError] = useState("");
  const [userId, setUserId] = useState(null);

  const questions = [
    {
      question:
        "Frage 1: Welches Protokoll wird üblicherweise für den sicheren Zugriff auf entfernte Server verwendet?",
      options: [
        {
          value: "A",
          label: "SSH (Secure Shell).",
        },
        {
          value: "B",
          label: "FTP (File Transfer Protocol).",
        },
      ],
      correct: "A",
    },
    {
      question:
        "Frage 2: Warum ist die Netzwerksegmentierung eine bewährte Sicherheitsstrategie?",
      options: [
        {
          value: "A",
          label: "Sie erhöht die maximale Bandbreite eines Netzwerks.",
        },
        {
          value: "B",
          label:
            "Sie verhindert, dass Angreifer sich frei im gesamten Netzwerk bewegen können.",
        },
      ],
      correct: "B",
    },
  ];
  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      scroller.scrollTo(location.hash.substring(1), {
        duration: 500,
        smooth: true,
        offset: -50,
      });
    }
  }, [location]);
  
  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged((user) => {
      if (user) {
        setUserId(user.uid); 
      } else {
        console.error("Kein authentifizierter Benutzer gefunden");
        setError("Benutzer ist nicht authentifiziert");
        navigate("/login"); 
      }
    });

    
    return () => unsubscribe();
  }, [navigate]);

  
  useEffect(() => {
    console.log("Aktuelle userId in 4_2.js:", userId);
  }, [userId]);

  const handleLogout = () => {
    
    auth
      .signOut()
      .then(() => {
        
        window.location.href = "/login"; 
      })
      .catch((error) => {
        console.error("Logout fehlgeschlagen:", error);
      });
  };

  const handleAnswerChange = (questionIndex, value) => {
    setSelectedAnswers((prev) => ({
      ...prev,
      [questionIndex]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const correctAnswers = questions.every(
      (q, index) => selectedAnswers[index] === q.correct
    );

    if (correctAnswers) {
      try {
        if (!userId) {
          console.error("userId ist nicht definiert");
          setError("Ein Fehler ist aufgetreten.");
          return;
        }

        
        const userDoc = await db.collection("users").doc(userId).get();

        console.log("userDoc:", userDoc.exists); 

        if (userDoc.exists) {
          
          await db
            .collection("users")
            .doc(userId)
            .update({
              lastChapter: "4_2",
              completedChapters:
                firebase.firestore.FieldValue.arrayUnion("4_2"),
            });
          console.log("Dokument aktualisiert mit Kapitel 4_2.");
        } else {
          
          await db
            .collection("users")
            .doc(userId)
            .set({
              lastChapter: "4_2",
              completedChapters: ["4_2"],
            });
          console.log("Dokument erstellt mit Kapitel 4_2.");
        }

        navigate("/4_3"); 
      } catch (error) {
        console.error("Fehler beim Aktualisieren des Fortschritts:", error);
        setError("Ein Fehler ist aufgetreten. Versuche es später erneut.");
      }
    } else {
      setError("Die Antworten sind nicht korrekt. Versuche es erneut.");
    }
  };
  return (
    <div className="container">
      <div className="container py-5">
        <img
          src="/images/zebbs_Logo.svg"
          class="d-block mx-auto mb-4"
          alt=""
          style={{ width: "20%" }}
        />
        <div className="d-flex justify-content-between align-items-center mb-5 p-3 bg-body-tertiary rounded-3">
          {/* Breadcrumbs */}
          <nav aria-label="breadcrumb">
            <ol className="breadcrumb breadcrumb-chevron mb-0">
              {/* Startseite (Home) */}
              <li className="breadcrumb-item">
                <Link className="link-body-emphasis" to="/course-overview">
                  <i className="bi bi-house-door-fill"></i>
                  <span className="visually-hidden">Home</span>
                </Link>
              </li>

              {/* Library Link */}
              <li className="breadcrumb-item">
                <Link
                  className="link-body-emphasis fw-semibold text-decoration-none"
                  to="/course-overview"
                >
                  4. Netzwerk und Netzwerksicherheit
                </Link>
              </li>

              {/* Aktuelle Seite */}
              <li className="breadcrumb-item active" aria-current="page">
                Netzwerkarchitektur
              </li>
            </ol>
          </nav>

          {/* Logout-Button */}
          <button className="btn btn-outline-dark" onClick={handleLogout}>
            Logout
          </button>
        </div>

        <div
          className="p-5 m-0 rounded-3"
          style={{
            position: "relative",
            backgroundColor: "#009fe0",
            margin: "25px",
            textAlign: "center",
          }}
        >
          <h3 className="text-center p-3">
            Kapitel 4: Netzwerk und Netzwerksicherheit
          </h3>
          <h2 className="text-center p-3">Netzwerkarchitektur</h2>
          <img
            src="/images/osi.png"
            alt="OSI"
            style={{ position: "relative", maxWidth: "30%", height: "auto" }}
          />
        </div>

        <div className="p-5 text-center">
          <h2 className="p-5">Netzwerkarchitektur</h2>
          <p className="col-lg-11 mx-auto">
            Eine gut durchdachte und sicher gestaltete Netzwerkarchitektur ist
            entscheidend, um Bedrohungen abzuwehren, Daten zu schützen und die
            Integrität des Netzwerks zu gewährleisten.
            <br />
            <br />
            Mit Netzwerkarchitekturen wird unter anderem festgelegt, wie verschiedene
            Komponenten und Netzwerkelemente miteinander verbunden sind. Die
            beiden am häufigsten verwendeten Architekturen sind die
            Client-Server-Architektur und die Peer-to-Peer-Architektur.
          </p>
        </div>
        <div class="row row-cols-1 row-cols-sm-2 row-cols-md-2 row-cols-lg-2 g-3 p-5">
          <div class="col d-flex align-items-start">
            <div class="p-3">
              <img
                src="/images/client-server.png"
                alt="Transparent"
                style={{
                  maxWidth: "20%",
                  height: "auto",
                }}
              />{" "}
              <h4 class="m-3">Client-Server-Architektur</h4>
              <p>
                Ein Client ist in einem Netzwerk ein Gerät oder ein Programm (
                z. B. ein Computer oder mobiles Endgerät ), das Daten oder
                Dienste von einem Server anfordert. Der Client ist sozusagen der
                "Nutzer" des Netzwerks, der etwas braucht. Der Server ist der
                "Anbieter", der diese Anfrage beantwortet. Die Server sind oft
                leistungsstarke Rechner, die Dateien, Anwendungen, Datenbanken
                oder andere Ressourcen zentral speichern und verwalten. Die
                Client-Server-Architektur bietet den Vorteil einer
                zentralisierten Kontrolle, einfacher Wartung und Skalierbarkeit.
                Die gesamte Netzwerkleistung hängt aber von der Verfügbarkeit
                und Kapazität der zentralen Server ab, was bei Ausfällen zu
                Störungen führen kann.
              </p>
            </div>
          </div>
          <div class="col d-flex align-items-start">
            <div class="p-3">
              <img
                src="/images/peer-to-peer.png"
                alt="Transparent"
                style={{
                  maxWidth: "20%",
                  height: "auto",
                }}
              />{" "}
              <h4 class="m-3">Peer-to-Peer-Architektur (P2P)</h4>
              <p>
                Bei der Peer-to-Peer-Architektur (P2P) sind alle Geräte im
                Netzwerk gleichberechtigt und können sowohl als Client als auch
                als Server fungieren. Jedes Gerät kann Ressourcen anbieten und
                gleichzeitig Ressourcen anderer Geräte nutzen. Diese
                dezentralisierte Struktur ist besonders nützlich für kleine
                Netzwerke. Der Vorteil liegt in der Unabhängigkeit von zentralen
                Servern und der Möglichkeit, Lasten auf alle Geräte zu
                verteilen. Allerdings können P2P-Netzwerke bei einer großen
                Anzahl von Geräten unübersichtlich werden. Sie sind tendenziell
                schwieriger abzusichern.
              </p>
            </div>
          </div>
        </div>

        <div className="grey-section">
          <div className="container p-5">
            <div className="p-5 text-center">
              <h2 className="p-5">Netzwerkkommunikation</h2>
              <p className="col-lg-11 mx-auto">
                Die Netzwerkkommunikation beschreibt, wie Daten in einem
                Netzwerk von einem Gerät zum anderen übertragen werden. Dabei
                werden die Informationen in sogenannte <strong> Pakete </strong>{" "}
                aufgeteilt. Diese Pakete enthalten nicht nur die eigentlichen
                Daten, sondern auch wichtige Zusatzinformationen, wie die
                Adresse des Empfängers und Steuerdaten, damit die Übertragung
                reibungslos funktioniert.
                <br />
                <br />
                Die Netzwerkkommunikation ist sehr komplex. Um einen Standard
                und eine Vorlage zu schaffen, an die sich Entwickler,
                Netzwerkingenieure und IT-Fachleute bei ihrer Arbeit halten
                können, wurde ein Referenzmodell entwickelt. Dieser 
                "Musterbauplan" wird als {" "}
                <strong>
                  {" "}
                  OSI-Modell (Open Systems Interconnection)
                </strong>{" "} bezeichnet. 
                <br />
                <br />
                Das OSI-Modell teilt die Netzwerkkommunikation in
                <strong>
                  {" "}
                  sieben übereinander liegende Schichten auf.{" "}
                </strong>{" "}
                Jede Schicht hat eine spezifische Aufgabe, wie z. B. das Senden der
                Daten, deren Sicherheit oder die richtige Weiterleitung. Wenn
                eine Nachricht (ein Datenpaket) übertragen wird, durchläuft sie
                immer alle sieben Schichten, wie ein Fahrstuhl der in einem Hochhaus über sieben Etagen nach oben fährt. Jede Schicht hat ihre eigene Funktion, bearbeitet nach bestimmten Protokollen
                das Datenpaket und schickt es dann weiter nach oben.
                <br />
                <br />
                Jede Schicht im OSI-Modell hat eigene Protokolle, die speziell
                für die Aufgaben dieser Schicht entwickelt wurden. Protokolle
                sind dabei wie Werkzeuge, die der jeweiligen Schicht helfen,
                ihre Funktion zu erfüllen. Diese Netzwerkprotokolle sind eine
                Art gemeinsame Sprache, die alle Geräte in einem Netzwerk sprechen müssen,
                um unabhängig von ihrer Hardware oder ihrem Betriebssystem
                miteinander kommunizieren zu können.
                <br />
                <br />
                Das Verständnis der Funktionen der OSI-Schichten ist für die
                Cybersecurity entscheidend, da jede Schicht nicht nur eine
                spezifische Aufgabe und Funktion hat, sondern auch spezifische
                Sicherheitsrisiken und Schwachstellen hat. Indem
                Sicherheitsmaßnahmen gezielt auf diese Schwachstellen jeder
                Schicht abgestimmt werden, können Netzwerke ganzheitlich
                geschützt und potenzielle Angriffe frühzeitig erkannt und
                abgewehrt werden.
              </p>
            </div>
          </div>

          <div className="container-md">
            <div className="row pb-5">
              <table class="table table-light table-striped-columns mb-5">
                <thead>
                  <tr>
                    <th scope="col">Schicht/Layer</th>
                    <th scope="col">Aufgabe</th>
                    <th scope="col">Protokolle</th>
                    <th scope="col">Sicherheitsrisiko</th>
                    <th scope="col">Schutzmaßnahme</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <th scope="row">
                      7. Anwendungsschicht <br /> (Application Layer)<br /> - unterste Schicht
                    </th>
                    <td>Interagiert direkt mit Benutzern und Anwendungen.</td>
                    <td>HTTP/HTTPS, FTP, SMTP</td>
                    <td>
                      {" "}
                      <Link to="/2_4" className="icon-link">
                        {" "}
                        <svg className="bi" aria-hidden="true">
                          {" "}
                          <use xlinkHref="#book"></use>{" "}
                        </svg>{" "}
                        Phishing,{" "}
                      </Link>{" "}
                      <Link to="/3_1" className="icon-link">
                        {" "}
                        <svg className="bi" aria-hidden="true">
                          {" "}
                          <use xlinkHref="#book"></use>{" "}
                        </svg>{" "}
                        Malware,{" "}
                      </Link>{" "}
                      <Link to="/3_3#sql" className="icon-link">
                        <svg className="bi" aria-hidden="true">
                          <use xlinkHref="#book"></use>
                        </svg>{" "}
                        SQL-Injection.
                      </Link>
                    </td>
                    <td>
                      Antivirus-Software, Sicherheitsupdates, Zugriffskontrolle,
                      sichere Entwicklungspraktiken, Eingabevalidierung,
                      Benutzerauthentifizierung, Awareness-Schulungen.
                    </td>
                  </tr>
                  <tr>
                    <th scope="row">
                      6. Darstellungsschicht <br /> (Presentation Layer)
                    </th>
                    <td>
                      Übersetzt die Daten in eine für die Anwendung
                      verständliche Form (z. B. von verschlüsselten Daten in
                      lesbaren Text)
                    </td>
                    <td>SSL/TLS, JPEG, PNG</td>
                    <td>Schwache Verschlüsselung, Formatierungsfehler</td>
                    <td>Starke Verschlüsselung, sichere Datenformate</td>
                  </tr>
                  <tr>
                    <th scope="row">
                      5. <br />
                      Sitzungsschicht <br /> (Session Layer)
                    </th>
                    <td>
                      Stellt sicher, dass eine Verbindung zwischen Sender und
                      Empfänger während der Datenübertragung aufrechterhalten
                      bleibt
                    </td>
                    <td>PPTP, NetBIOS</td>
                    <td>Sitzungsübernahme, Replay-Angriffe</td>
                    <td>
                      Sitzungstokens, Authentifizierung, Schutz vor
                      Replay-Angriffen
                    </td>
                  </tr>
                  <tr>
                    <th scope="row">
                      4. <br />
                      Transportschicht <br /> (Transport Layer)
                    </th>
                    <td>
                      Zerlegt Daten in Pakete und gewährleistet korrekte
                      Reihenfolge
                    </td>
                    <td>TCP, UDP</td>
                    <td>Port-Scans, TCP-SYN-Flooding, Verbindungsübernahme</td>
                    <td>
                      TLS/SSL, Verbindungsverschlüsselung, Einsatz von Intrusion
                      Detection (IDS)
                    </td>
                  </tr>

                  <tr>
                    <th scope="row">
                      3. <br />
                      Netzwerkschicht <br /> (Network Layer)
                    </th>
                    <td>
                      Findet den besten Weg für Datenpakete und adressiert sie.
                    </td>
                    <td>IP, ICMP, OSPF</td>
                    <td>
                      {" "}
                      <Link to="/3_5" className="icon-link">
                        {" "}
                        <svg className="bi" aria-hidden="true">
                          {" "}
                          <use xlinkHref="#book"></use>{" "}
                        </svg>{" "}
                        Man-in-the-Middle{" "}
                      </Link>{" "}
                      IP-Spoofing
                    </td>
                    <td>
                      Firewalls,{" "}
                      <Link to="/3_5#vpn" className="icon-link">
                        <svg className="bi" aria-hidden="true">
                          <use xlinkHref="#book"></use>
                        </svg>{" "}
                        VPNs
                      </Link>
                      IPsec, Netzwerküberwachung
                    </td>
                  </tr>
                  <tr>
                    <th scope="row">
                      2. <br />
                      Datensicherungs-
                      <br />
                      schicht <br /> (Data Link Layer)
                    </th>
                    <td>
                      Stellt eine fehlerfreie Übertragung zwischen den Geräten
                      sicher
                    </td>
                    <td>Ethernet, ARP, PPP</td>
                    <td>Datenkorruption, MAC-Spoofing, ARP-Spoofing</td>
                    <td>
                      Einsatz von Prüfsummen, Authentifizierung, Port-Sicherheit
                    </td>
                  </tr>
                  <tr>
                    <th scope="row">
                      1. <br />
                      Physische Schicht <br /> (Physical Layer) <br />- oberste Schicht
                    </th>
                    <td>
                      Überträgt Daten als Signale über Kabel, Funk oder
                      Glasfaser
                    </td>
                    <td>Ethernet (Kabel), Wi-Fi, Bluetooth</td>
                    <td>
                      Physische Sabotage, Abhören, Störsender, Zugriff auf
                      Hardware
                    </td>
                    <td>
                      Physische Zugangskontrollen, Glasfaserkabel (schwerer
                      abzuhören), Hardwareüberwachung
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>

        <div className="white-section">
          <div className="container">
            <div className="p-5 text-center">
              <h2 className="p-5">Netzwerkprotokolle</h2>
              <p className="col-lg-11 mx-auto">
                Netzwerkprotokolle sind essenziell für die Kommunikation in
                Computernetzwerken. Sie regeln, wie Daten gesendet, empfangen
                und verarbeitet werden. Sie lassen sich in verschiedene
                Kategorien einteilen. Jedes Protokoll hat seine Funktion, birgt
                aber auch potenzielle Sicherheitsrisiken. Hier ein detaillierter Überblick:
              </p>{" "}
              <br />
              <br />
              <h4 className="pb-3">1. Übertragungs- und Routing-Protokolle</h4>
              <p className="col-lg-11 mx-auto text-start">
                <ul>
                  <li>
                    <strong>IP (Internet Protocol):</strong>
                    <ul>
                      <li>
                        Funktion: Zuständig für die Adressierung und
                        Weiterleitung von Datenpaketen zwischen Netzwerken.
                        Jedes Datenpaket wird mit einer Quell- und
                        Ziel-IP-Adresse versehen.
                      </li>{" "}
                      <li>
                        Sicherheitsrisiko: Angreifer können durch IP-Spoofing
                        gefälschte IP-Adressen verwenden, um sich als
                        vertrauenswürdige Quelle auszugeben und Netzwerke zu
                        kompromittieren.
                      </li>
                      <br />
                    </ul>
                  </li>
                  <li>
                    <strong>ICMP (Internet Control Message Protocol):</strong>
                    <ul>
                      <li>
                        Funktion: Dient zur Übermittlung von Fehler- und
                        Statusmeldungen, etwa bei Netzwerkproblemen. Es
                        ermöglicht Funktionen wie "Ping", um Verbindungen zu
                        überprüfen.
                      </li>{" "}
                      <li>
                        Sicherheitsrisiko: ICMP kann für{" "}
                        <Link to="/3_4" className="icon-link">
                          {" "}
                          <svg className="bi" aria-hidden="true">
                            {" "}
                            <use xlinkHref="#book"></use>{" "}
                          </svg>{" "}
                          Denial-of-Service-Angriffe{" "}
                        </Link>{" "}
                        (DoS) missbraucht werden, bei denen Netzwerke durch eine
                        Überflutung mit ICMP-Anfragen überlastet werden.
                      </li>
                      <br />
                    </ul>
                  </li>
                </ul>
              </p>{" "}
              <br />
              <br />
              <h4 className="pb-3">2. Transportschicht-Protokolle</h4>
              <p className="col-lg-11 mx-auto text-start">
                Diese Protokolle gewährleisten die zuverlässige Übertragung von
                Daten zwischen Anwendungen auf verschiedenen Geräten. Sie sorgen
                dafür, dass Datenpakete vollständig und korrekt ankommen. <br />{" "}
                <br />
                <ul>
                  <li>
                    <strong>TCP (Transmission Control Protocol):</strong>
                    <ul>
                      <li>
                        Funktion: Stellt sicher, dass Datenpakete zuverlässig,
                        in der richtigen Reihenfolge und ohne Verluste
                        übertragen werden. Es bietet Fehlerkorrektur und
                        Bestätigungsmechanismen.
                      </li>{" "}
                      <li>
                        Sicherheitsrisiko: TCP ist anfällig für
                        SYN-Flood-Angriffe, bei denen Angreifer gefälschte
                        Verbindungsanfragen senden, um Serverressourcen zu
                        erschöpfen.
                      </li>{" "}
                      <br />
                    </ul>
                  </li>
                  <li>
                    <strong>UDP (User Datagram Protocol):</strong>
                    <ul>
                      <li>
                        Funktion: Überträgt Daten ohne Bestätigung und ist
                        schneller als TCP, da keine Fehlerkorrektur erfolgt.
                        Ideal für Echtzeitanwendungen wie Streaming oder
                        Online-Gaming.
                      </li>{" "}
                      <li>
                        Sicherheitsrisiko: UDP kann für Reflection-Angriffe
                        genutzt werden, bei denen Server für DoS-Angriffe
                        missbraucht werden, da UDP-Anfragen keine
                        Authentifizierung erfordern.
                      </li>{" "}
                      <br />
                    </ul>
                  </li>
                </ul>
              </p>{" "}
              <br />
              <br />
              <h4 className="pb-3">3. Anwendungsprotokolle</h4>
              <p className="col-lg-11 mx-auto text-start">
                Diese Protokolle operieren auf der höchsten Ebene des
                OSI-Modells und regeln die Kommunikation zwischen Anwendungen.
                Sie definieren, wie Daten strukturiert und übertragen werden.
                <br /> <br />
                <ul>
                  <li>
                    <strong>HTTP (Hypertext Transfer Protocol):</strong>
                    <ul>
                      <li>
                        Funktion: Ermöglicht den Abruf und die Anzeige von
                        Webseiten über Webbrowser. Es ist das Standardprotokoll
                        für das Surfen im Internet.
                      </li>
                      <li>
                        Sicherheitsrisiko: HTTP-Daten werden unverschlüsselt
                        übertragen und können von Angreifern abgefangen werden,
                        was zu Man-in-the-Middle-Angriffen (MITM) führen kann.{" "}
                      </li>{" "}
                      <br />
                    </ul>
                  </li>
                  <li>
                    <strong>FTP (File Transfer Protocol):</strong>
                    <ul>
                      <li>
                        Funktion: Ermöglicht das Hoch- und Herunterladen von
                        Dateien zwischen Computern in einem Netzwerk.
                      </li>
                      <li>
                        Sicherheitsrisiko: FTP überträgt Benutzerdaten und
                        Passwörter im Klartext, was es anfällig für
                        Abhörangriffe (Sniffing) macht.
                      </li>{" "}
                      <br />
                    </ul>
                  </li>
                  <li>
                    <strong>SMTP (Simple Mail Transfer Protocol):</strong>
                    <ul>
                      <li>
                        Funktion: Regelt den Versand von E-Mails zwischen
                        Servern. Es sorgt dafür, dass Nachrichten korrekt
                        zugestellt werden.{" "}
                      </li>
                      <li>
                        Sicherheitsrisiko: SMTP ist anfällig für
                        E-Mail-Spoofing, bei dem Angreifer gefälschte
                        Absenderadressen verwenden, um Phishing-Angriffe
                        durchzuführen.{" "}
                      </li>
                    </ul>
                  </li>
                </ul>
              </p>{" "}
              <br />
              <br />
              <h4 className="pb-3">4. Sicherheitsprotokolle</h4>
              <Element name="ssl">
                <p className="col-lg-11 mx-auto text-start">
                  Diese Protokolle verschlüsseln und sichern die
                  Datenübertragung, insbesondere bei sensiblen Informationen,
                  die über öffentliche Netzwerke übertragen werden.
                  <br /> <br />
                  <ul>
                    <li>
                      <strong>
                        HTTPS (Hypertext Transfer Protocol Secure):
                      </strong>
                      <ul>
                        <li>
                          HTTPS ist die sichere Version von HTTP – also des Protokolls, mit dem Webseiten geladen werden. Es sorgt dafür, dass die Daten zwischen deinem Browser und der Website verschlüsselt übertragen werden, sodass Dritte sie nicht mitlesen oder verändern können. Deshalb wird HTTPS besonders bei sensiblen Anwendungen wie Online-Banking, Webshops oder Login-Seiten verwendet.
                        </li>
                        <li>
                          Sicherheitsrisiko: Wenn ein Server falsch konfiguriert ist oder ein unsicheres Zertifikat verwendet, können Angreifer versuchen, die verschlüsselte Verbindung zu manipulieren – etwa durch sogenannte „Man-in-the-Middle“-Angriffe oder SSL-Stripping.
                        </li>{" "}
                        <br />
                      </ul>
                    </li>
                    <li>
                      <strong>
                        SSL/TLS (Secure Sockets Layer/Transport Layer Security):
                      </strong>
                      <ul>
                        <li>
                          SSL und sein moderner Nachfolger TLS sind die technischen Verfahren hinter HTTPS. Sie verschlüsseln die Daten, bevor sie über das Internet übertragen werden. TLS ist dabei die aktuelle und sichere Variante – SSL gilt heute als veraltet.
                        </li>
                        <li>
                          Sicherheitsrisiko: Alte oder unsichere Protokollversionen wie SSL 3.0 oder TLS 1.0 enthalten bekannte Schwachstellen und können gezielt angegriffen werden. Deshalb sollten sie in modernen Systemen deaktiviert sein.
                          oder POODLE.
                        </li>{" "}
                        <br />
                      </ul>
                    </li>
                  </ul>
                </p>
              </Element>
              <p className="col-lg-11 mx-auto d-inline-flex p-5 m-5 text-decoration-none border-danger rounded-2">
                <img
                  src="/images/fact.svg"
                  alt="Transparent"
                  style={{
                    position: "relative",
                    maxWidth: "8%",
                    height: "auto",
                  }}
                />
                Das TCP- und das IP-Protokoll wurden 1970 im Auftrag des
                US-Verteidigungsministerium entwickelt, um eine
                Kommunikationsmöglichkeit zu schaffen, die selbst nach einem
                nuklearen Angriff noch funktionieren würde. Ursprünglich waren
                sie Teil des ARPANET. Die Robustheit und Flexibilität dieser
                beiden zusammenarbeitenden Protokolle bildet aber bis heute das
                Rückgrat des Internet. Ohne TCP/IP wäre die zuverlässige und
                weltweite Kommunikation, wie wir sie heute kennen, nicht
                möglich. Es ist die Grundlage von Diensten wie E-Mail, Webseiten
                und Videostreaming.
              </p>
            </div>
          </div>
        </div>

        <div className="container">
          <div
            className="safe rounded-2 text-center"
            style={{ backgroundColor: "#fec748" }}
          >
            <img
              src="/images/abwehr.svg"
              alt="Abwehr"
              style={{
                position: "relative",
                maxWidth: "7%",
                height: "auto",
              }}
            />
            <h3 className="p-5">Netzwerksegmentierung</h3>
            <Element name="netzsegment">
              <p className="col-lg-11 mx-auto">
                                
                Bei der Netzwerksegmentierung wird ein Netzwerk in kleinere,
                logisch getrennte Bereiche <strong> (Segmente) </strong>{" "}
                unterteilt, die jeweils unabhängig voneinander verwaltet werden.
                Diese Strategie reduziert die Angriffsfläche erheblich, da sich
                ein Angreifer, der Zugang zu einem Segment erlangt hat, nicht
                ohne Weiteres im gesamten Netzwerk ausbreiten kann. Jedes
                Segment kann eigene Sicherheitsrichtlinien und
                Zugriffskontrollen erhalten, die speziell auf die darin
                enthaltenen Geräte und Anwendungen zugeschnitten sind.
                <br />
                <br />
                In modernen IT-Infrastrukturen kommt zunehmend die{" "}
                <strong> Mikrosegmentierung </strong> zum Einsatz. Hierbei wird
                nicht nur das Netzwerk grob in Zonen unterteilt, sondern jedes
                einzelne Gerät, jede Anwendung oder sogar bestimmte Datenströme
                erhalten eigene Sicherheitsrichtlinien. Besonders sensible Daten
                und kritische Systeme können so in isolierten
                <strong> „Hochsicherheitszonen“ </strong> geschützt werden. Dies
                ermöglicht es Administratoren,{" "}
                <span
                  data-tooltip-id="tooltip-gr"
                  data-tooltip-content="Granulare Richtlinien sind sehr detaillierte Regeln, die genau festlegen, wer welche Berechtigungen hat und unter welchen Bedingungen. Sie ermöglichen eine feinkörnige Steuerung von Zugriffsrechten und Prozessen, anstatt nur allgemeine Vorgaben zu machen. So können beispielsweise bestimmte Benutzer unterschiedliche Rechte oder Einschränkungen für dieselbe Anwendung oder Ressource haben."
                  className="custom-tooltip-trigger"
                >
                  {" "}
                  granulare Richtlinien{" "}
                </span>{" "}
                anzuwenden, anstatt allgemeine Sicherheitsmaßnahmen auf das
                gesamte Netzwerk auszurollen. Dadurch wird nicht nur die
                Sicherheitslage verbessert, sondern auch die Einhaltung von
                <strong> Compliance-Anforderungen </strong> erleichtert.
                <br />
                <br />
                Ein weiterer Vorteil der Netzwerksegmentierung liegt in der
                <strong> vereinfachten Überwachung und Kontrolle </strong> des
                Datenverkehrs. Durch die gezielte Überwachung der Kommunikation
                zwischen den einzelnen Segmenten können Administratoren
                verdächtige Aktivitäten frühzeitig erkennen und schneller darauf
                reagieren. Sicherheitslösungen wie Intrusion Detection Systems
                (IDS) oder Firewalls lassen sich gezielt für den Datenverkehr
                zwischen Segmenten einsetzen, um unerwünschte Zugriffe zu
                blockieren.
                <br />
                <br />
                Allerdings bringt die Einführung von Netzwerksegmentierung auch
                Herausforderungen mit sich. Eine sorgfältige Planung ist
                erforderlich, um festzulegen, welche Systeme und Geräte in
                welchen Segmenten platziert werden sollen. Zudem müssen
                Segmentierungsregeln regelmäßig überprüft und an veränderte
                Geschäfts- oder Sicherheitsanforderungen angepasst werden. Ohne
                konsequente Wartung und regelmäßige Überprüfung können
                Fehlkonfigurationen entstehen, die neue Sicherheitslücken
                schaffen.
              </p>
              <ReactTooltip
                id="tooltip-gr"
                place="top"
                className="custom-tooltip"
              />
            </Element>

 <p className="col-lg-9 mx-auto d-inline-flex p-5 m-5 text-decoration-none border-danger rounded-2">
                <img
                  src="/images/fact.svg"
                  alt="Transparent"
                  style={{
                    position: "relative",
                    maxWidth: "8%",
                    height: "auto",
                  }}
                />
                Netzwerksegmentierung verhindert nicht unbedingt einen Angriff – aber sie begrenzt dessen Ausbreitung massiv.

Viele große Ransomware-Fälle wurden nicht deshalb so teuer, weil der erste Server kompromittiert wurde, sondern weil sich der Angreifer anschließend ungehindert durch das interne Netzwerk bewegen konnte („Lateral Movement“). Wenn jedoch sensible Systeme – etwa Datenbanken, Backup-Server oder Produktionssysteme – in getrennten Netzwerksegmenten mit klaren Zugriffskontrollen liegen, kann sich Schadsoftware nicht einfach im gesamten Unternehmen ausbreiten.

Ein zentraler Gedanke dabei lautet:
Nicht jedes System muss mit jedem anderen System sprechen können.
              </p>


          </div>
        </div>
      </div>
      {/* Fragenteil */}
      <div className="container pt-5 my-5">
        <div className="text-center m-4">
          <h2>Überprüfe dein Wissen</h2>
          <p className="col-lg-11 mx-auto">
            Mit den richtigen Antworten kommst du weiter!
          </p>
        </div>
        <div className="row justify-content-center">
          <div className="col-md-9 text-start">
            <form onSubmit={handleSubmit}>
              {questions.map((question, index) => (
                <div key={index} className="mb-4">
                  <p className="fs-4">{question.question}</p>{" "}
                  {question.options.map((option) => (
                    <div key={option.value} className="form-check">
                      <input
                        className="form-check-input me-2"
                        type="radio"
                        name={`question${index}`}
                        value={option.value}
                        checked={selectedAnswers[index] === option.value}
                        onChange={() => handleAnswerChange(index, option.value)}
                      />
                      <label className="form-check-label fs-5">
                        {option.label}
                      </label>{" "}
                    </div>
                  ))}
                </div>
              ))}
              {error && <p className="text-danger">{error}</p>}
              <div className="text-center">
                <button type="submit" className="btn btn-primary">
                  überprüfen
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
      {/* Ende Fragenteil */}
    </div>
  );
};

export default Chapter4_2;
